
import { defineComponent, onMounted } from 'vue';
import InactiveCoffeeCustomersList from '../components/InactiveCoffeeCustomersList.vue';
import { setPageHeader } from '@/core/helpers/toolbar';

export default defineComponent({
    components: {
        InactiveCoffeeCustomersList
    },
    setup() {
        onMounted(() => {
            setPageHeader({
                title: 'message.INACTIVE_COFFEE_CUSTOMERS_REPORT',
                actionButton: {
                    ability: '',
                    pageAction: {
                        action: ''
                    },
                    button: {}
                },
                breadCrumbs: [
                    { name: 'message.HOME', link: '/dashboard' },
                    { name: 'message.REPORTS', link: '#' },
                    { name: 'message.INACTIVE_COFFEE_CUSTOMERS_REPORT' }
                ]
            });
        });
    }
});
